import React from 'react';
import { AppButton, Box, Text, useResponsive, WarningIcon } from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

interface Props {
  contentStyle?: React.CSSProperties;
  visible: boolean;
  close: () => void;
}
export const testId = 'DuplicationErrorModal';
export const DuplicationErrorModal: React.FC<Props> = ({ contentStyle, visible, close }) => {
  const { isMobile } = useResponsive();
  return (
    <ModalWrapper
      contentStyle={contentStyle || { maxWidth: '672px' }}
      visible={visible}
      onSetVisible={close}
      testId={`${testId}_modal`}
    >
      <Box direction="column" align="center" pad={{ vertical: 'spacing24' }}>
        <WarningIcon data-testid={`${testId}_modal_round_close`} size="48px" />
        <Box
          pad={
            isMobile
              ? { top: 'spacing12', bottom: 'spacing16' }
              : { top: 'spacing12', bottom: 'spacing24', horizontal: 'spacing128' }
          }
        >
          <Text weight="bold" data-testid={`${testId}_modal_header`} textAlign="center" size="24px">
            Warning
          </Text>
          <Text data-testid={`${testId}_modal_description`} textAlign="center" margin={{ top: 'spacing12' }}>
            The account information provided already matches the account on file. You are all set!
          </Text>
        </Box>
        <Box direction="row" align="center" fill={isMobile} justify="center">
          <AppButton
            testId={`${testId}_modal_submit`}
            width={isMobile ? undefined : '200px'}
            fill={isMobile}
            onClick={close}
          >
            Got It!
          </AppButton>
        </Box>
      </Box>
    </ModalWrapper>
  );
};
